/* ============================================================
   SMARTY GEAR — Global JavaScript
   assets/smartygear.js
   ============================================================ */

(function () {
  'use strict';

  /* ── NAV SCROLL ── */
  var sgNav = document.getElementById('sg-nav');
  if (sgNav) {
    window.addEventListener('scroll', function () {
      sgNav.classList.toggle('scrolled', window.pageYOffset > 80);
    }, { passive: true });
  }

  /* ── SCROLL REVEAL ── */
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('vis');
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.rv').forEach(function (el) { obs.observe(el); });

  /* ── SMOOTH SCROLL ── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    if (a.closest('.sg-mobile-menu')) return;
    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    var target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ── PRODUCT FILTER TABS ── */
  window.sgFilterProducts = function (cat, btn) {
    document.querySelectorAll('.sg-ptab').forEach(function (t) {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-selected', 'true');
    document.querySelectorAll('.sg-prod').forEach(function (p) {
      if (cat === 'all' || p.dataset.cat === cat) {
        p.style.display = '';
        setTimeout(function () { p.style.opacity = '1'; p.style.transform = 'translateY(0)'; }, 50);
      } else {
        p.style.opacity = '0';
        p.style.transform = 'translateY(10px)';
        setTimeout(function () { p.style.display = 'none'; }, 300);
      }
    });
  };

  /* ── CART DRAWER ── */
  var cartDrawer = document.getElementById('sg-cart-drawer');
  var cartOverlay = document.getElementById('sg-cart-overlay');
  var cartClose = document.getElementById('sg-cart-close');
  var cartCount = document.querySelectorAll('.sg-cart-count');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartUI(cart);
      })
      .catch(function (err) { console.error('Cart fetch error:', err); });
  }

  function updateCartCount(count) {
    cartCount.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateCartUI(cart) {
    updateCartCount(cart.item_count);
    var itemsEl = document.getElementById('sg-cart-items');
    var totalEl = document.getElementById('sg-cart-total');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="sg-cart-empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return '<div class="sg-cart-item">' +
          '<img src="' + item.image + '" alt="' + item.title + '" class="sg-cart-item__img">' +
          '<div class="sg-cart-item__info">' +
          '<p class="sg-cart-item__title">' + item.title + '</p>' +
          '<p class="sg-cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="sg-cart-item__qty">' +
          '<button class="sg-qty-btn" onclick="sgUpdateQty(' + item.key + ', ' + (item.quantity - 1) + ')">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button class="sg-qty-btn" onclick="sgUpdateQty(' + item.key + ', ' + (item.quantity + 1) + ')">+</button>' +
          '</div></div></div>';
      }).join('');
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-AE', { style: 'currency', currency: 'AED' });
  }

  window.sgUpdateQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(updateCartUI);
  };

  // Open cart from nav icon
  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Add to cart intercept
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: data.get('id'), quantity: data.get('quantity') || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { fetchCart(); openCart(); })
      .catch(function (err) { console.error('Add to cart error:', err); });
  });

  /* ── ANNOUNCEMENT BAR CLOSE ── */
  var annClose = document.getElementById('sg-ann-close');
  var annBar = document.getElementById('sg-ann-bar');
  if (annClose && annBar) {
    annClose.addEventListener('click', function () {
      annBar.style.display = 'none';
      sessionStorage.setItem('sg-ann-closed', '1');
    });
    if (sessionStorage.getItem('sg-ann-closed')) annBar.style.display = 'none';
  }

  /* ── INTEREST CHIPS (Consultation form) ── */
  var consultForm = document.getElementById('sg-consultation-form');
  if (consultForm) {
    consultForm.addEventListener('submit', function () {
      var active = [];
      consultForm.querySelectorAll('.sg-chip.on').forEach(function (c) {
        active.push(c.textContent.trim());
      });
      var hidden = document.getElementById('sg-form-interests');
      if (hidden) hidden.value = active.join(', ');
    });
  }

  /* ── WISHLIST ── */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('sg-wishlist') || '[]'); } catch(e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('sg-wishlist', JSON.stringify(list)); } catch(e) {}
  }
  window.sgToggleWishlist = function (productId, btn) {
    var list = getWishlist();
    var idx = list.indexOf(productId);
    if (idx > -1) {
      list.splice(idx, 1);
      btn.style.color = '';
    } else {
      list.push(productId);
      btn.style.color = 'var(--sg-gold)';
    }
    saveWishlist(list);
  };

  // Restore wishlist state on load
  var savedList = getWishlist();
  document.querySelectorAll('[data-wishlist-id]').forEach(function (btn) {
    if (savedList.indexOf(btn.dataset.wishlistId) > -1) {
      btn.style.color = 'var(--sg-gold)';
    }
  });

  /* ── INIT ── */
  fetchCart();

})();


(function () {

  function initMobileMenu() {
    var hamburger = document.getElementById('sg-hamburger');
    var mobileMenu = document.getElementById('sg-mobile-menu');
    var closeBtn   = document.getElementById('sg-mobile-close');
    var backdrop   = document.getElementById('sg-mobile-backdrop');

    if (!hamburger || !mobileMenu) { console.warn('[SG] Mobile menu elements not found'); return; }
    if (hamburger.dataset.sgInit === 'true') return;
    hamburger.dataset.sgInit = 'true';

    function openMenu() {
      hamburger.classList.add('open');
      mobileMenu.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function toggleAccordion(itemEl) {
      var btn     = itemEl.querySelector('.sg-mobile-menu__toggle');
      var submenu = itemEl.querySelector('.sg-mobile-submenu');
      var isOpen  = btn && btn.getAttribute('aria-expanded') === 'true';

      // Close all other accordions
      mobileMenu.querySelectorAll('.sg-mobile-menu__item.sg-mobile-has-children').forEach(function (li) {
        if (li === itemEl) return;
        var b = li.querySelector('.sg-mobile-menu__toggle');
        var s = li.querySelector('.sg-mobile-submenu');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (s) s.classList.remove('open');
      });

      // Toggle this one
      if (btn)     btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (submenu) submenu.classList.toggle('open', !isOpen);
    }

    hamburger.addEventListener('click', function () {
      mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (backdrop)  backdrop.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
    });

    mobileMenu.addEventListener('click', function (e) {

      // 1. Chevron toggle button
      var toggle = e.target.closest('.sg-mobile-menu__toggle');
      if (toggle) {
        e.preventDefault();
        var item = toggle.closest('.sg-mobile-menu__item');
        if (item) toggleAccordion(item);
        return;
      }

      // 2. Child link — always navigate
      var link = e.target.closest('.sg-mobile-link');
      if (link) {
        if (link.classList.contains('sg-mobile-link--child')) {
          closeMenu();
          return;
        }

        // 3. Parent link with children — toggle accordion
        var item = link.closest('.sg-mobile-menu__item');
        if (item && item.classList.contains('sg-mobile-has-children')) {
          e.preventDefault();
          toggleAccordion(item);
          return;
        }

        // 4. Plain top-level link — close and navigate
        closeMenu();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('#sg-hamburger')) {
      var h = document.getElementById('sg-hamburger');
      if (h) h.dataset.sgInit = '';
      initMobileMenu();
    }
  });

})();